<template>
  <v-dialog :value="open" width="640px" @click:outside="onClose">
    <v-card v-if="image != null">
      <v-card-title>{{label("confirmMessage")}}</v-card-title>
      <div class="d-flex flex-row flex-wrap justify-center">
        <v-img
            :src="image.url"
            max-width="320px"
            max-height="180px"
            class="ma-2"
        />
      </div>
      <v-card-actions>
        <v-spacer/>
        <ActionButton
            type="submit"
            width="240px"
            @click="onDelete"
        >
          {{label("delete")}}
        </ActionButton>
        <ActionButton
            type="cancel"
            width="240px"
            @click="onClose"
        >
          {{label("cancel")}}
        </ActionButton>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ActionButton from "@/components/molecules/ActionButton";
import ComponentMixin from "@/components/ComponentMixin";
export default {
  mixins: [ComponentMixin],
  type: "organism",
  name: "ImageDeleteConfirmDialog",
  components: {ActionButton},
  props: {
    open: {
      type: Boolean,
      required: true
    },
    image: {
      type: Object
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onDelete(e, guard) {
      this.$emit("delete", this.image, guard);
    }
  }
}
</script>

<style scoped>

</style>
